import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-be479db4")

_pushScopeId("data-v-be479db4")
const _hoisted_1 = { class: "main component" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { style: {"padding-top":"10px"} }, "Boxed Category List", -1)
const _hoisted_3 = { class: "ant-pro-table-list-toolbar" }
const _hoisted_4 = { style: {"display":"flex","gap":"10px","padding":"10px"} }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Create")
const _hoisted_7 = {
  key: 0,
  style: {"font-style":"italic","color":"gray"}
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Submit ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_table = _resolveComponent("a-table")
  const _component_a_card = _resolveComponent("a-card")
  const _component_a_alert = _resolveComponent("a-alert")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_card, {
      style: {"margin-top":"16px"},
      "body-style": { padding: 0 }
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_a_input, {
              value: _ctx.category_id_filter,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.category_id_filter = $event)),
              size: "large",
              placeholder: "Category ID"
            }, null, 8, ["value"]),
            _createVNode(_component_a_input, {
              value: _ctx.category_name_filter,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.category_name_filter = $event)),
              size: "large",
              placeholder: "Category Name"
            }, null, 8, ["value"]),
            _createVNode(_component_a_button, {
              class: "filter-button",
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getTableData()))
            }, {
              default: _withId(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              class: "filter-button",
              type: "primary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openCreateModal('create')))
            }, {
              default: _withId(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_a_table, {
          size: 'small',
          columns: _ctx.columns,
          "data-source": _ctx.rows,
          onChange: _ctx.handleTableChange,
          pagination: _ctx.pagination
        }, {
          image: _withId(({ record }) => [
            _createVNode("a", {
              href: record.signed_image,
              target: "_blank",
              style: {"float":"left"}
            }, [
              _createVNode("img", {
                src: record.signed_image,
                alt: record.name,
                style: {"max-width":"100px","max-height":"100px","display":"block"}
              }, null, 8, ["src", "alt"])
            ], 8, ["href"])
          ]),
          viewMore: _withId(({ record }) => [
            _createVNode("a", {
              href: "#",
              style: {"color":"blue"},
              onClick: ($event: any) => (_ctx.openEditModal(record, 'edit'))
            }, "View", 8, ["onClick"]),
            _createVNode("a", {
              href: "#",
              style: {"color":"red","margin-left":"10px"},
              onClick: _withModifiers(($event: any) => (_ctx.deleteRow(record)), ["prevent"])
            }, "Delete", 8, ["onClick"]),
            (record.deleteLoading)
              ? (_openBlock(), _createBlock("a", _hoisted_7, "Deleting..."))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "data-source", "onChange", "pagination"])
      ]),
      _: 1
    }),
    (_ctx.modalMode === 'create' || _ctx.modalMode === 'edit')
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 0,
          visible: _ctx.showModal,
          "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (_ctx.showModal = $event)),
          width: "1000px",
          footer: false,
          title: _ctx.modalMode === 'create' ? 'Create Category' : 'Edit Category'
        }, {
          default: _withId(() => [
            _createVNode(_component_a_form, {
              layout: "vertical",
              class: "form-layout"
            }, {
              default: _withId(() => [
                (_ctx.isError)
                  ? (_openBlock(), _createBlock(_component_a_alert, {
                      key: 0,
                      type: "error",
                      "show-icon": "",
                      style: {"margin-bottom":"24px"},
                      message: "Sorry, something went wrong logging you in. Please check your internet connection and login credentials and try again."
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_form_item, null, {
                  default: _withId(() => [
                    _createVNode(_component_a_input, {
                      size: "large",
                      placeholder: "Category ID",
                      style: {"width":"100%"},
                      value: _ctx.category_id,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.category_id = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, null, {
                  default: _withId(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.category_name,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.category_name = $event)),
                      size: "large",
                      placeholder: "Category Name"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { style: {"margin-top":"24px"} }, {
                  default: _withId(() => [
                    _createVNode(_component_a_button, {
                      size: "large",
                      type: "primary",
                      "html-type": "submit",
                      class: "submit-button",
                      loading: _ctx.loading,
                      disabled: _ctx.loading,
                      onClick: _ctx.submit
                    }, {
                      default: _withId(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["visible", "title"]))
      : _createCommentVNode("", true)
  ]))
})